// @ts-nocheck
import * as Types from "../../../../../types/types";

import { gql } from "@apollo/client";
import { FingerprintQueryDetailsFragmentDoc } from "../../FingerprintQueryDetails/gql/Fragment.generated";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type OrganizationQueryDetailsQueryVariables = Types.Exact<{
  organizationSlug: Types.Scalars["ID"]["input"];
  fingerprint: Types.Scalars["ID"]["input"];
  serverGroupId?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
  datname?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
  startTs: Types.Scalars["Int"]["input"];
  endTs: Types.Scalars["Int"]["input"];
}>;

export type OrganizationQueryDetailsQuery = {
  __typename?: "GraphqlQuery";
  getQueryStatsForFingerprint?: {
    __typename?: "QueryFingerprintStats";
    id: string;
    fingerprint: string;
    normalizedQuery: string;
    truncatedQuery: string;
    avgTime: number;
    callsPerMinute: number;
  } | null;
};

export const OrganizationQueryDetailsDocument = gql`
  query OrganizationQueryDetails(
    $organizationSlug: ID!
    $fingerprint: ID!
    $serverGroupId: ID
    $datname: String
    $startTs: Int!
    $endTs: Int!
  ) {
    getQueryStatsForFingerprint(
      organizationSlug: $organizationSlug
      fingerprint: $fingerprint
      serverGroupId: $serverGroupId
      datname: $datname
      startTs: $startTs
      endTs: $endTs
    ) {
      ...FingerprintQueryDetails
    }
  }
  ${FingerprintQueryDetailsFragmentDoc}
`;

/**
 * __useOrganizationQueryDetailsQuery__
 *
 * To run a query within a React component, call `useOrganizationQueryDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQueryDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQueryDetailsQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *      fingerprint: // value for 'fingerprint'
 *      serverGroupId: // value for 'serverGroupId'
 *      datname: // value for 'datname'
 *      startTs: // value for 'startTs'
 *      endTs: // value for 'endTs'
 *   },
 * });
 */
export function useOrganizationQueryDetailsQuery(
  baseOptions: Apollo.QueryHookOptions<
    OrganizationQueryDetailsQuery,
    OrganizationQueryDetailsQueryVariables
  > &
    (
      | { variables: OrganizationQueryDetailsQueryVariables; skip?: boolean }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    OrganizationQueryDetailsQuery,
    OrganizationQueryDetailsQueryVariables
  >(OrganizationQueryDetailsDocument, options);
}
export function useOrganizationQueryDetailsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    OrganizationQueryDetailsQuery,
    OrganizationQueryDetailsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    OrganizationQueryDetailsQuery,
    OrganizationQueryDetailsQueryVariables
  >(OrganizationQueryDetailsDocument, options);
}
// @ts-ignore
export function useOrganizationQueryDetailsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    OrganizationQueryDetailsQuery,
    OrganizationQueryDetailsQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  OrganizationQueryDetailsQuery,
  OrganizationQueryDetailsQueryVariables
>;
export function useOrganizationQueryDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationQueryDetailsQuery,
        OrganizationQueryDetailsQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  OrganizationQueryDetailsQuery | undefined,
  OrganizationQueryDetailsQueryVariables
>;
export function useOrganizationQueryDetailsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        OrganizationQueryDetailsQuery,
        OrganizationQueryDetailsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    OrganizationQueryDetailsQuery,
    OrganizationQueryDetailsQueryVariables
  >(OrganizationQueryDetailsDocument, options);
}
export type OrganizationQueryDetailsQueryHookResult = ReturnType<
  typeof useOrganizationQueryDetailsQuery
>;
export type OrganizationQueryDetailsLazyQueryHookResult = ReturnType<
  typeof useOrganizationQueryDetailsLazyQuery
>;
export type OrganizationQueryDetailsSuspenseQueryHookResult = ReturnType<
  typeof useOrganizationQueryDetailsSuspenseQuery
>;
export type OrganizationQueryDetailsQueryResult = Apollo.QueryResult<
  OrganizationQueryDetailsQuery,
  OrganizationQueryDetailsQueryVariables
>;
